import React, { FC, useState } from 'react';
import { useStaticPermission } from 'common/auth/Authorize';
import { DataTableToolbar } from '@utmost.co/utmost-design-system';
import { IconButton } from '@beeline.com/bp-design-system';
import { useCustomObjectValuesIntl } from '@oc/pages/settings/CustomFieldsAndObjects/Objects/CustomObjectValues/translations/useCustomObjectValuesIntl';
import { CreateEditCustomObjectValueDialog } from '@oc/pages/settings/CustomFieldsAndObjects/Objects/CustomObjectValues/CreateEditCustomObjectValueDialog';

interface Props {
  value: string;
  onValueChange: (value: string) => void;
  totalCount: number;
  pageDataCount: number;
  onSubmitDone: () => void;
  customObjectDefinitionUid: string | undefined;
}

export const CustomObjectValuesToolbar: FC<React.PropsWithChildren<Props>> = ({
  onSubmitDone,
  value,
  onValueChange,
  totalCount,
  pageDataCount,
  customObjectDefinitionUid
}) => {
  const intl = useCustomObjectValuesIntl();
  const { CREATE } = useStaticPermission('CUSTOM_FIELD_DEFINITION');

  const [openCreateModal, setOpenCreateModal] = useState(false);
  return (
    <>
      <DataTableToolbar
        message={intl.customObjectValuesTotalCount({ totalCount, pageDataCount })}
        searchProps={{
          value,
          onValueChange
        }}
        beforeActions={
          <IconButton
            disabled={!CREATE}
            disabledToolTipText={intl.noPermissionForAction}
            tooltipText={intl.createCustomObject}
            iconName="add"
            dataTest="add-custom-object-value"
            onClick={() => setOpenCreateModal(true)}
          />
        }
      />
      <CreateEditCustomObjectValueDialog
        onCloseModal={() => setOpenCreateModal(false)}
        onCreate={onSubmitDone}
        onEdit={onSubmitDone}
        isOpen={openCreateModal}
        isEdit={false}
        model={undefined}
        customObjectDefinitionUid={customObjectDefinitionUid}
      />
    </>
  );
};
